<template>
  <div class="filter-comp">
    <template v-if="filterList.length < 6">
      <el-tag v-for="(tag, index) in filterList" :key="tag.name" closable type="info" style="background: white; margin-right: 10px;" @close="close(tag, index)">
        {{tag.name}}
      </el-tag>
    </template>
    <el-popover v-else placement="bottom" trigger="hover">
      <el-tag v-for="(tag, index) in filterList" :key="tag.name" closable type="info" style="background: white; margin-right: 10px;" @close="close(tag, index)">
        {{tag.name}}
      </el-tag>
      <p class="clear-all pointer" @click="$emit('closeAll')">{{ $t('Index.Components.Filter.ClearAll') }}</p>
      <span slot="reference" class="pointer"><i class="iconfont icon-filter-3-line" style="margin-right: 5px;"></i>{{ $t('Index.Components.Filter.Filter') }}</span>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    filterList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    close(tag, index) {
      this.$emit('close', tag, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-comp{

}
.clear-all{
  color: #99C41C;
  text-align: center;
  padding-top: 15px;
}
</style>
